import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import { selectIsWebview } from '../selectors/selectIsWebview';
import { EStepCode } from '../types/form';
import { setQueryParams } from './setQueryParams';

export const useSetWebViewUrl = () => {
  const isWebView = useSelector(selectIsWebview);

  const setStepQuery = useCallback(
    (currentStep: EStepCode) => {
      if (isWebView) {
        setQueryParams({
          currentStep,
        });
      }
    },
    [isWebView],
  );

  const setIsFinishedQuery = useCallback(() => {
    if (isWebView) {
      setQueryParams({
        isFinished: true,
      });
    }
  }, [isWebView]);

  return {
    setStepQuery,
    setIsFinishedQuery,
  };
};
